module.exports = __webpack_public_path__ + "static/herobg-fbbb8b7ddb989727353d8bfd31cf02ad.png";